export const HISTORY_ALL_CATEGORIES = 'all-categories'
export const HISTORY_VISIBLE_GROUP_CHANGES = 3
export const HISTORY_WIDE_GRID_CLASS =
  '@4xl/history:grid-cols-[minmax(0,1.2fr)_minmax(0,1fr)_minmax(0,.55fr)_32px_minmax(0,1.5fr)_minmax(0,.8fr)]'
